import React from 'react';
import { Dialog, DialogContent, Grid, Button, Typography, Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { PaymentMethod } from 'common/types';
import classNames from 'classnames';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'services/localization';

interface OwnProps {
	open: boolean;
	paymentMethods: PaymentMethod[];
	handleClose: () => void;
	handlePaymentMethodSelection: (paymentMethod: PaymentMethod) => void;
}

type Props = OwnProps & WithStyles<typeof styles>;

const CustomPaymentMethodsDialog = (props: Props) => {
	const classes = props.classes;
	const theme = useTheme();
	const { t } = useTranslation();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Dialog open={props.open} fullScreen={fullScreen} maxWidth="md">
			<DialogContent className={classes.content}>
				<div />
				<Grid container spacing={2} justifyContent="flex-start" className={classes.methodsWrapper}>
					{props.paymentMethods.map((method) => (
						<Grid item className={classes.methodItem}>
							<Button
								className={classNames(classes.standardCell, classes.methodCellWrapper)}
								fullWidth
								variant="contained"
								color="primary"
								onClick={() => props.handlePaymentMethodSelection(method)}
							>
								<Typography variant="body1">{method}</Typography>
							</Button>
						</Grid>
					))}
				</Grid>
				<div className={classes.closeBtn}>
					<Button onClick={props.handleClose} variant="outlined" color="secondary">
						{t('common:actions.close', 'Close')}
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		title: {
			textAlign: 'right',
		},
		closeBtn: {
			marginTop: theme.spacing(2),
		},
		content: {
			padding: theme.spacing(2),
			textAlign: 'center',
		},
		methodsWrapper: {
			padding: theme.spacing(4, 2),
		},
		methodItem: {
			flex: '0 1 33%',
			minWidth: 160,
			maxWidth: 220,
		},
		standardCell: {
			border: `1px solid ${theme.palette.primary.main}`,
			borderRadius: 5,
			position: 'relative',
			cursor: 'pointer',
			padding: 0,
			minWidth: 0,
			minHeight: 0,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		methodCellWrapper: {
			height: `calc(80px - ${theme.spacing(1)})`,
		},
	});

export default withStyles(styles)(CustomPaymentMethodsDialog);
